import * as API from "../../../../api";
import { LinearLoader } from "../../../../components/linear-loader/LinearLoader";
import { useSnackbar } from "../../../../components/minimal/snackbar";
import { useEffect } from "react";
import { useAuthContext } from "../../../../context-state/AuthContext.jsx";
import { useNavigate } from "react-router-dom";
import { useEndUsersContext } from "../../../../context-state/EndUsersContext.jsx";
import { useLocales } from "../../../../locales";

export const EndUsersGuard = ({ children }) => {

    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();
    const { getPrimaryAccount } = useAuthContext()
    const sellerAccount = getPrimaryAccount()
    const { getEndUsersOfSellerAccount, updateManyEndUsers, updateSellerAccountToEndUsersRelation, setPaginationData, updateManySegments, updateSellerAccountToSegmentRelation, updateSegmentToEndUsersRelation, setEventsData, setSeasonTicketsData, reload, setActivityData } = useEndUsersContext()
    const endUsersLoaded = getEndUsersOfSellerAccount(sellerAccount?._id)
    const { translate } = useLocales()

    const getEndUserData = async () => {
        try {
            if (!sellerAccount) {
                console.error('sellerAccount is not defined')
                navigate('/dashboard')
                enqueueSnackbar(translate("end_user.data_error"), { variant: 'error' })
                return
            }
            const marketplaceId = sellerAccount.marketPlace._id
            if (!marketplaceId) {
                navigate('/dashboard')
                enqueueSnackbar(translate("end_user.data_error"), { variant: 'error' })
                return
            }

            const [endUsersResponse, segmentsResponse, eventsResponse, seasonTicketsResponse, activityResponse] = await Promise.all([
                API.getEndUsersOfAccount({ accountId: sellerAccount._id, marketplaceId: sellerAccount.marketPlace._id }),
                API.getSegmentsOfAccount({ accountId: sellerAccount._id, marketplaceId: sellerAccount.marketPlace._id }),
                API.getSellerEventsPaginated({ sellerId: sellerAccount._id, limit: 500 }),
                API.getSeasonTicketsOfSellerPublic({ sellerId: sellerAccount._id, marketplaceId: sellerAccount.marketPlace._id }),
                API.getCrmEventTypes({ sellerId: sellerAccount._id, marketplaceId: sellerAccount.marketPlace._id }),
            ])

            const endUsersOfSegmentsResponses = segmentsResponse.data.map(segment => {
                return API.getEndUsersOfSegment({ accountId: sellerAccount._id, marketplaceId: sellerAccount.marketPlace._id, segmentId: segment._id }).then(res => ({ segmentId: segment._id, endUsers: res.data }))
            })

            const endUsersOfSegments = await Promise.all(endUsersOfSegmentsResponses)

            updateManyEndUsers(endUsersResponse.data.data)
            updateSellerAccountToEndUsersRelation(sellerAccount._id, endUsersResponse.data.data)

            updateManySegments(segmentsResponse.data)
            updateSellerAccountToSegmentRelation(sellerAccount._id, segmentsResponse.data)
            updateSegmentToEndUsersRelation(endUsersOfSegments)

            const { limit, count } = endUsersResponse.data.pagination
            endUsersResponse.data.pagination.hasMore = limit < count
            setPaginationData(endUsersResponse.data.pagination) // {limit: 10, page: 1, count: 95} (count is the total number of end users in the account)
            setEventsData(eventsResponse.data)
            setSeasonTicketsData(seasonTicketsResponse.data)
            setActivityData(activityResponse.data)
        } catch (e) {
            enqueueSnackbar(e.userFacingMessage || e.message, { variant: 'error' })
            console.error(e);
        }
    }

    useEffect(() => {
        getEndUserData()
    }, [reload])

    return (
        endUsersLoaded ? children : <LinearLoader />
    )
}
